import { differenceInCalendarDays, differenceInSeconds, isSameYear, parseISO } from 'date-fns'

const pickRelative = (
  seconds: number,
  now: Date,
  date: Date,
): [number, Intl.RelativeTimeFormatUnit] | null => {
  if (seconds < 3600) return [-Math.floor(seconds / 60), 'minute']
  if (seconds < 86400) return [-Math.floor(seconds / 3600), 'hour']
  if (differenceInCalendarDays(now, date) === 1) return [-1, 'day']
  return null
}

export const formatTimestamp = (timestamp: string, now: Date = new Date()): string => {
  const { t, locale } = useI18n()
  const date = parseISO(timestamp)

  const seconds = differenceInSeconds(now, date)
  if (seconds < 60) return t('common.time.relative.justnow')

  const relative = pickRelative(seconds, now, date)
  if (relative) {
    return new Intl.RelativeTimeFormat(locale.value, { numeric: 'auto', style: 'long' }).format(
      ...relative,
    )
  }

  const format = isSameYear(date, now) ? 'monthDay' : 'date'
  return formatDate(date, format, undefined, locale.value)
}
